const memory = new Map();
const key = uid => `kashtu-settings-draft:${uid}`;
function read(uid) {
  if(memory.has(uid))return memory.get(uid);
  let value={};
  try { value=JSON.parse(sessionStorage.getItem(key(uid)) || "{}"); } catch {}
  memory.set(uid,value);return value;
}
function write(uid,value) {
  memory.set(uid,value);
  try { Object.keys(value).length?sessionStorage.setItem(key(uid),JSON.stringify(value)):sessionStorage.removeItem(key(uid)); } catch {}
}
export function clearSettingsDraft(uid,ids) {
  const draft=read(uid);for(const id of ids)delete draft[id];write(uid,draft);
}
export function restoreSettingsDraft(root,uid,ids) {
  const draft=read(uid);
  for(const id of ids){
    const input=root.querySelector(`#${id}`);if(!input)continue;
    const checked=input.type==="checkbox";
    const baseline=checked?input.checked:input.value;
    if(draft[id]===baseline)delete draft[id];
    if(Object.hasOwn(draft,id)){if(checked)input.checked=draft[id];else input.value=draft[id];}
    const update=()=>{
      const value=checked?input.checked:input.value;
      if(value===baseline)delete draft[id];else draft[id]=value;
      write(uid,draft);paint();
    };
    input.addEventListener("input",update);input.addEventListener("change",update);
  }
  function paint(){
    const note=root.querySelector(".draft-status");
    if(note)note.textContent=Object.keys(draft).length?"Unsaved edits — kept in this tab while you move around. Save each edited group when ready.":"Training, body details, and profile info save with their own Save button.";
  }
  paint();write(uid,draft);
}
